// web/src/billing/CadenceToggle.tsx
//
// Pill switch between "Monthly" and "Annual" pricing on /pricing. Annual
// is highlighted with the implied savings; the actual price math lives
// in PlanCard.
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";

export type Cadence = "monthly" | "annual";

interface Props {
  value: Cadence;
  onChange: (next: Cadence) => void;
}

export function CadenceToggle({ value, onChange }: Props) {
  return (
    <RadioGroup
      value={value}
      onValueChange={(v) => onChange(v as Cadence)}
      className="inline-flex items-center rounded-full border border-border bg-muted/40 p-1"
    >
      <div className="flex items-center gap-2 px-3 py-1.5 rounded-full data-[state=checked]:bg-background">
        <RadioGroupItem value="monthly" id="cadence-monthly" className="sr-only" />
        <Label
          htmlFor="cadence-monthly"
          className={`text-sm cursor-pointer ${
            value === "monthly" ? "font-semibold" : "text-muted-foreground"
          }`}
        >
          Monthly
        </Label>
      </div>
      <div className="flex items-center gap-2 px-3 py-1.5 rounded-full">
        <RadioGroupItem value="annual" id="cadence-annual" className="sr-only" />
        <Label
          htmlFor="cadence-annual"
          className={`text-sm cursor-pointer ${
            value === "annual" ? "font-semibold" : "text-muted-foreground"
          }`}
        >
          Annual
          <span className="ms-2 text-xs text-emerald-600">save ~17%</span>
        </Label>
      </div>
    </RadioGroup>
  );
}
